import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';

import {
  property as propertyPropType,
  user as userPropType,
  account as accountPropType,
  bafm as bafmPropType,
  myOrders as myOrdersPropType,
  orderBookStatus as orderBookStatusPropType,
  propertyAccess as propertyAccessPropType,
} from 'scripts/constants/PropTypes';

import BrickValuationBar from 'scripts/components/property/trade/BrickValuationBar';
import Constants from 'scripts/constants/Constants';
import FinancialsPanel from 'scripts/components/shared/FinancialsPanel';
import Loading from 'src/components/loading/Loading';
import LowestAvailableBricksPriceBox from 'scripts/components/property/trade/LowestAvailableBricksPriceBox';
import Modal from 'scripts/components/helpers/Modal';
import PrimaryButton from 'src/design/components/button/PrimaryButton';
import SegmentEventTypes from 'scripts/redux/actions/segment/SegmentEventTypes';
import Spacing from 'src/design/styleguide/spacing/Spacing';

import { bafmSelector } from 'scripts/redux/selectors/bafm';
import { accountSelector } from 'scripts/redux/selectors/account';
import {
  myOrdersSelector,
  bricksTransactedLastMonthSelector,
  orderBookStatusSelector,
  propertyAccessSelector,
} from 'scripts/redux/selectors/market';
import { fetchBafm } from 'scripts/redux/actions/bafm';
import {
  fetchOrderBookStatus,
  fetchPropertyAccess,
  fetchNumOfBricksTransactedLastMonth,
} from 'scripts/redux/actions/market';
import { sendFirstPremiumAlertEvent } from 'scripts/redux/actions/segment/events/tradeEvents';
import { sendPopupSignupSubmitEvent } from 'scripts/redux/actions/segment/events/loginOrSignupPopupEvents';

import {
  brick,
  brickPrice,
  percent,
  monthYear,
} from 'scripts/utilities/formatters';
import {
  getBrickValuation,
  getPriceDifferencePercentage,
  isANewProperty,
  // shouldFirstPremiumAlertBeTriggered,
} from 'scripts/utilities/propertyHelper';
import { isUserLoggedIn } from 'scripts/utilities/userAccountHelper';
import buyingSellingDisabled from 'scripts/buyingSellingDisabled';

import { aboveBelowValuationHelpUrl } from 'src/utils/pageUrls';
import { toggleModal as toggleLoginOrSignupModalAction } from 'src/store/loginOrSignupModalActions';
import { renderCode } from 'src/settings/properties';

const mapStateToProps = (state) => ({
  ...bafmSelector(state),
  ...accountSelector(state),
  ...myOrdersSelector(state),
  ...bricksTransactedLastMonthSelector(state),
  ...orderBookStatusSelector(state),
  ...propertyAccessSelector(state),
});

export const VoteAction = ({ voteUrl }) => (
  <Spacing top="small">
    {voteUrl ? (
      <PrimaryButton
        testRef="vote-button"
        color={PrimaryButton.colors.SECONDARY}
        link={voteUrl}
        fullWidth
        arrow
      >
        VOTE
      </PrimaryButton>
    ) : (
      <PrimaryButton
        testRef="vote-open-button"
        color={PrimaryButton.colors.PRIMARY}
        fullWidth
        disabled
      >
        VOTE OPEN
      </PrimaryButton>
    )}
  </Spacing>
);

VoteAction.propTypes = {
  voteUrl: PropTypes.string,
};

@connect(mapStateToProps, {
  fetchBafm,
  fetchOrderBookStatus,
  fetchPropertyAccess,
  fetchNumOfBricksTransactedLastMonth,
  toggleLoginOrSignupModal: toggleLoginOrSignupModalAction,
})
export default class InvestPanelMarketOpen extends Component {
  static propTypes = {
    user: userPropType.isRequired,
    account: accountPropType,
    myOrders: myOrdersPropType.isRequired,
    property: propertyPropType.isRequired,
    orderBookStatus: orderBookStatusPropType.isRequired,
    propertyAccess: propertyAccessPropType.isRequired,
    bricksTransactedLastMonth: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    bafm: bafmPropType,
    fetchOrderBookStatus: PropTypes.func.isRequired,
    fetchPropertyAccess: PropTypes.func.isRequired,
    fetchNumOfBricksTransactedLastMonth: PropTypes.func.isRequired,
    fetchBafm: PropTypes.func.isRequired,
    fetchMyOrdersInfo: PropTypes.func.isRequired,
    handleBuyButtonClick: PropTypes.func.isRequired,
    handleSellButtonClick: PropTypes.func.isRequired,
    getTotalBricksOwned: PropTypes.func.isRequired,
    toggleLoginOrSignupModal: PropTypes.func.isRequired,
  };

  state = {
    orderBookEnabled: true,
    canAccessProperty: true,
    tradeError: null,
    isUpdatedWithUserInfo: false,
    buyButtonClickedWhileUserLoggedOut: false,
    sellButtonClickedWhileUserLoggedOut: false,
    bricksTransactedInLastMonth: '- Bricks',
  };

  componentDidMount() {
    const {
      user,
      property,
      fetchBafm,
      fetchOrderBookStatus,
      fetchPropertyAccess,
      fetchNumOfBricksTransactedLastMonth,
      fetchMyOrdersInfo,
    } = this.props;
    fetchMyOrdersInfo(user);
    fetchBafm();
    fetchOrderBookStatus(property.propertyCode);
    fetchPropertyAccess(property.propertyCode);
    fetchNumOfBricksTransactedLastMonth(property.propertyCode);
    this._updateBricksTransactedInLastMonth(
      this.props.bricksTransactedLastMonth,
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !_.isNil(nextProps.bricksTransactedLastMonth) &&
      nextProps.bricksTransactedLastMonth !==
        this.props.bricksTransactedLastMonth
    ) {
      this._updateBricksTransactedInLastMonth(
        nextProps.bricksTransactedLastMonth,
      );
    }

    const hasUserBeenUpdated = nextProps.user !== this.props.user;
    if (hasUserBeenUpdated) {
      this.props.fetchMyOrdersInfo(nextProps.user);
      if (isUserLoggedIn(nextProps.user) && !isUserLoggedIn(this.props.user)) {
        this._performActionAfterLoginPopup(nextProps.user);
      }
    }
  }

  componentDidUpdate() {
    const { orderBookStatus, propertyAccess } = this.props;
    const orderBookStatusUpdated = !_.isNil(orderBookStatus)
      ? orderBookStatus.enabled !== this.state.orderBookEnabled
      : false;
    if (orderBookStatusUpdated) {
      this._updateOrderBookEnabledValue();
    }
    const propertyAccessUpdated = !_.isNil(propertyAccess)
      ? propertyAccess.canAccess !== this.state.canAccessProperty
      : false;
    if (propertyAccessUpdated) {
      this._updateCanAccessPropertyValue();
    }
  }

  render() {
    const { user, account, property, getTotalBricksOwned, myOrders } =
      this.props;
    const { bricksTransactedInLastMonth } = this.state;

    const hasBricks = getTotalBricksOwned(account, myOrders) > 0;
    const { brickValuation } = getBrickValuation(property);
    const priceDifferencePercentage = getPriceDifferencePercentage(property);

    const buyButton = () => (
      <PrimaryButton
        testRef="buy-bricks-button"
        color={PrimaryButton.colors.SECONDARY}
        onClick={() => this._handleBuyButtonClick(user)}
        arrow
        fullWidth
        disabled={buyingSellingDisabled}
      >
        BUY BRICKS
      </PrimaryButton>
    );

    const sellButton = () => (
      <PrimaryButton
        testRef="sell-bricks-button"
        color={PrimaryButton.colors.PRIMARY}
        onClick={() => this._handleSellButtonClick(user)}
        arrow
        fullWidth
        disabled={buyingSellingDisabled}
      >
        SELL BRICKS
      </PrimaryButton>
    );

    const actionButtons = (className) => {
      if (property.propertyStatus === 'vote_open') {
        return <VoteAction voteUrl={property.voteUrl} />;
      }

      if (property.propertyStatus === 'vote_closed') {
        return (
          <Spacing top="small">
            <PrimaryButton
              color={PrimaryButton.colors.PRIMARY}
              fullWidth
              disabled
            >
              LIVE SALE CAMPAIGN
            </PrimaryButton>
          </Spacing>
        );
      }

      return (
        <Fragment>
          {buyButton(classNames('buy-button', className))}
          <Spacing top="x-small">
            {sellButton(classNames('sell-button', className))}
          </Spacing>
        </Fragment>
      );
    };

    return (
      <div className="invest-panel">
        <div className="mobile visible-xs">
          <BrickValuationBar
            property={property}
            showIcon={Constants.TRUE}
            showValuationDate={Constants.TRUE}
          />
          <LowestAvailableBricksPriceBox
            property={property}
            showAboveBelowValuation={Constants.TRUE}
            isMobileVersion={Constants.TRUE}
          />
          {actionButtons()}
          <div className="trade-error">
            <b>{this.state.tradeError || <div>&nbsp;</div>}</b>
          </div>
          <p className="bricks-sold-last-month">
            <span className="bricks">{bricksTransactedInLastMonth}</span>
            {` transacted in ${renderCode(
              property.propertyCode,
            )} (last 30 days)`}
          </p>
        </div>
        <FinancialsPanel
          className="panel-financials-blue-header panel-financials-invest hidden-xs"
          title={`Invest in ${renderCode(property.propertyCode)}`}
        >
          <LowestAvailableBricksPriceBox
            property={property}
            showAboveBelowValuation
            isMobileVersion={Constants.FALSE}
          />

          {isANewProperty(property) ? (
            <div>
              <div className="row table-row">
                <BrickValuationBar
                  property={property}
                  showIcon={Constants.FALSE}
                  showValuationDate
                />
              </div>
            </div>
          ) : (
            <div className="row table-row">
              {property.financials.lowestAvailableBrickPrice > 0 ? (
                <div>
                  <BrickValuationBar
                    property={property}
                    showIcon={Constants.FALSE}
                    showValuationDate
                  />
                </div>
              ) : (
                <div className="col-md-12 col-xs-12 asterisk-info copy">
                  Check back later to see if any Bricks have been listed for
                  sale. If you already own Bricks in this property, you can
                  click below to place a Sell Order.
                </div>
              )}
            </div>
          )}

          {actionButtons('trade-button')}

          <div className="trade-error">
            <b>{this.state.tradeError || <div>&nbsp;</div>}</b>
          </div>
          <p className="bricks-sold-last-month">
            <span className="bricks">{bricksTransactedInLastMonth}</span>
            {` transacted in ${renderCode(
              property.propertyCode,
            )} over the last 30 days.`}
          </p>
        </FinancialsPanel>

        <Modal
          ref={(el) => (this.noBricksModal = el)}
          title="No Bricks Currently Available"
          id="no-brickx-modal"
          sizeClass="modal-md"
          body={
            <div>
              <p className="margin-bottom">{`Currently there are 0 Bricks for sale in ${renderCode(
                property.propertyCode,
              )}. Check back later to see if any Bricks have been listed.`}</p>
              {!_.isNil(account) && !_.isNil(myOrders) ? (
                <div>
                  {hasBricks && (
                    <div>
                      <p>
                        Already own Bricks? If you already own Bricks in{' '}
                        {renderCode(property.propertyCode)} and would like to
                        place a sell order, click below.
                      </p>
                      <p
                        className="button trade-button sell-button orange-button"
                        onClick={() => {
                          this.noBricksModal.close();
                          this._handleSellButtonClick(user);
                        }}
                      >
                        SELL BRICKS&nbsp;
                        <span className="fa fa-angle-right"></span>
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                <Loading />
              )}
            </div>
          }
        />

        <Modal
          ref={(el) => (this.aboveValuationFirstAlertModal = el)}
          title={
            <span className="text-orange">
              <span className="fa fa-exclamation-triangle" /> ATTENTION: Above
              Valuation Alert
            </span>
          }
          id="premium-price-first-alert-modal"
          sizeClass="modal-md"
          onClose={this._handleCancelledAboveValuationButtonClick}
          footer={
            <div>
              <button
                className="button cancel-button right-arrow-button"
                onClick={() => {
                  this.aboveValuationFirstAlertModal.close();
                  this._sendCancelledAboveValuationEvent();
                }}
              >
                <span>CANCEL</span>
              </button>
              <button
                className="button trade-button sell-button orange-button confirm-high-price right-arrow-button"
                onClick={() => {
                  this.aboveValuationFirstAlertModal.close();
                  this._handleProcessAboveValuationButtonClick();
                }}
              >
                I ACKNOWLEDGE, PROCEED
              </button>
            </div>
          }
          body={
            <div>
              <p>Please read the following.</p>
              <ul>
                <li>
                  The current Lowest Available Brick Price for this property is{' '}
                  <span className="text-orange">
                    {property.financials.lowestAvailableBrickPrice::brickPrice()}
                  </span>
                </li>
                <li>
                  The last valuation of a Brick in this property from{' '}
                  {property.financials.latestValuationDate::monthYear()} is{' '}
                  <span className="text-orange">
                    {brickValuation::brickPrice()}
                  </span>
                </li>
              </ul>
              <p>
                If you were to purchase the lowest priced Brick you would be{' '}
                <span className="text-orange">
                  paying {priceDifferencePercentage::percent()} more
                </span>{' '}
                than the last valuation (
                {property.financials.latestValuationDate::monthYear()}). This
                could negatively impact your investment returns.
              </p>
              For more information, please read the short article on{' '}
              <a href={aboveBelowValuationHelpUrl()} target="_blank">
                <u>
                  Understanding Above and Below Valuations on the BrickX
                  Platform
                </u>
              </a>
              .
            </div>
          }
        />
      </div>
    );
  }

  _updateOrderBookEnabledValue = () => {
    this.setState({ orderBookEnabled: this.props.orderBookStatus.enabled });
  };

  _updateCanAccessPropertyValue = () => {
    this.setState({ canAccessProperty: this.props.propertyAccess.canAccess });
  };

  _updateBricksTransactedInLastMonth = (bricksTransactedLastMonth) => {
    if (!_.isNil(bricksTransactedLastMonth)) {
      this.setState({
        bricksTransactedInLastMonth: bricksTransactedLastMonth::brick(),
      });
    }
  };

  _handleBuyButtonClick = (user) => {
    const { property, handleBuyButtonClick, toggleLoginOrSignupModal } =
      this.props;
    const { orderBookEnabled, canAccessProperty } = this.state;
    if (isUserLoggedIn(user)) {
      if (!orderBookEnabled) {
        this.setState({
          tradeError: `The Order Book for ${renderCode(property.propertyCode)} is currently closed`,
        });
      } else if (!canAccessProperty) {
        this.setState({
          tradeError: `You do not have access to the property ${renderCode(property.propertyCode)}`,
        });
      } else {
        handleBuyButtonClick();
      }
      // } else if (shouldFirstPremiumAlertBeTriggered(property)) {
      //   setTimeout(() => this.aboveValuationFirstAlertModal.open(), 100); // eslint-disable-line no-magic-numbers
      // } else if (property.financials.lowestAvailableBrickPrice > 0) {
      // setTimeout(() => this.noBricksModal.open(), 100); // eslint-disable-line no-magic-numbers
    } else {
      this.setState({ buyButtonClickedWhileUserLoggedOut: true });
      const trackingProps = {
        launchedFrom: 'Buy Bricks Button',
        propertyCode: this.props.property.propertyCode,
      };
      toggleLoginOrSignupModal({
        trackingProps,
        onSubmit: () => sendPopupSignupSubmitEvent(trackingProps),
      });
    }
  };

  _handleSellButtonClick = (user) => {
    const {
      account,
      myOrders,
      bafm,
      property,
      handleSellButtonClick,
      getTotalBricksOwned,
      toggleLoginOrSignupModal,
    } = this.props;
    if (isUserLoggedIn(user)) {
      const totalBricksOwned = getTotalBricksOwned(account, myOrders);
      if (!this.state.orderBookEnabled) {
        this.setState({
          tradeError: `The Order Book for ${renderCode(property.propertyCode)} is currently closed`,
        });
      } else if (!this.state.canAccessProperty) {
        this.setState({
          tradeError: `You do not have access to the property ${renderCode(property.propertyCode)}`,
        });
      } else if (totalBricksOwned === 0) {
        this.setState({
          tradeError: `You do not own any Bricks in ${renderCode(property.propertyCode)}`,
        });
      } else if (bafm && bafm.hasBafm) {
        this.setState({
          tradeError:
            'Cannot sell Bricks: You have deposited using POLi recently and the funds were advanced to your BrickX Wallet while the bank transfer happens in the back ground. As soon as the transfer arrives at BrickX, the restrictions will be lifted from your account.',
        });
      } else {
        handleSellButtonClick();
      }
    } else {
      this.setState({ sellButtonClickedWhileUserLoggedOut: true });
      toggleLoginOrSignupModal();
    }
  };

  _performActionAfterLoginPopup = async (user = this.props.user) => {
    const { property, fetchPropertyAccess } = this.props;
    const {
      buyButtonClickedWhileUserLoggedOut,
      sellButtonClickedWhileUserLoggedOut,
    } = this.state;

    if (buyButtonClickedWhileUserLoggedOut) {
      await fetchPropertyAccess(property.propertyCode);
      this._handleBuyButtonClick(user);
      this.setState({ buyButtonClickedWhileUserLoggedOut: false });
    }
    if (sellButtonClickedWhileUserLoggedOut) {
      await fetchPropertyAccess(property.propertyCode);
      this._handleSellButtonClick(user);
      this.setState({ sellButtonClickedWhileUserLoggedOut: false });
    }
  };

  _handleProcessAboveValuationButtonClick = () => {
    const { handleBuyButtonClick } = this.props;
    this.aboveValuationFirstAlertModal.close();
    this._sendProceedAboveValuationEvent();
    handleBuyButtonClick();
  };

  _handleCancelledAboveValuationButtonClick = () => {
    this._sendCancelledAboveValuationEvent();
  };

  _sendProceedAboveValuationEvent = () => {
    sendFirstPremiumAlertEvent(
      SegmentEventTypes.TRADE.PREMIUM_PRICE_ALERTS_ENGAGEMENT.PROCEED,
    );
  };

  _sendCancelledAboveValuationEvent = () => {
    sendFirstPremiumAlertEvent(
      SegmentEventTypes.TRADE.PREMIUM_PRICE_ALERTS_ENGAGEMENT.CANCELLED,
    );
  };
}
